export const setInLocalStorage = (key: string, value: string) => {
	if (typeof window === 'undefined') return
	localStorage[key] = value
}

export const getInLocalStorage = (key: string) => {
	if (typeof window === 'undefined') return
	return localStorage[key]
}
